window.scenarios = window.scenarios || [];

window.scenarios["3bm4s"] = {"name": "3bm4s", "cookie":"buyukMobilyaView", "widget": "shw_favorites_3"};
window.scenarios["3dl_500p_4s"] = {"name": "3dl_500p_4s", "cookie":"demonteLiving500View", "widget": "welcome_coupon_1"};

$(document).ready(function () {

    if (window.userId == "0"){

        var scenario1 = window.scenarios["3bm4s"];
        var scenario2 = window.scenarios["3dl_500p_4s"];

        // Lead Generation - 3 Büyük Mobilya Bakıldıysa, 4 Saniye sonra Showroom Lead Generation Widget Göster
        if (!Vivense.cookie.exist(scenario1.name + '_Closed') && Vivense.cookie.exist(scenario1.cookie) && Vivense.cookie.get(scenario1.cookie).split(',').length >= 3){

            setTimeout(function(){
                $('.showroom-widget-wrapper').removeClass("showroom-widget-shown");

                if (!Vivense.cookie.exist(scenario1.name + '_Shown')){
                    Vivense.populate.insertEvent(scenario1.name, window.currentPage, "self", scenario1.widget, 5);
                    Vivense.cookie.set(scenario1.name + '_Shown', '1', 15 * 24);
                }
            }, 4000);

        } else if (!Vivense.cookie.exist(scenario2.name + '_Closed') && Vivense.cookie.exist(scenario2.cookie) && Vivense.cookie.get(scenario2.cookie).split(',').length >= 3){

            setTimeout(function(){
                $('.coupon-widget-wrapper').addClass("coupon-widget-shown");

                if (!Vivense.cookie.exist(scenario2.name + '_Shown')){
                    Vivense.populate.insertEvent(scenario2.name, window.currentPage, "self", scenario2.widget, 5);
                    Vivense.cookie.set(scenario2.name + '_Shown', '1', 15 * 24);
                }
            }, 4000);
        }
    }


});